export enum SortOptionsForTaskList {
    publicNameAsc,
    publicNameDesc,
    creationTimeAsc,
    creationTimeDesc,
    modificationTimeAsc,
    modificationTimeDesc,
  }